import useAuthStore from '@/context/useAuth'
import { Cookie } from '@/utils/base/cookie'
import axios from 'axios'

/**
 * Giriş yapmış kullanıcının bilgileri doğrular hatalı bir durumda giriş yapmaya yönlendirir.
 * Aynı zamanda kullanıcı bilgileri ile ilgili bir değişiklik yapıldığında loginChecker fonksiyonu
 * çalıştırılarak güncellenen verinin ui tarafında da güncel hali gösterilmesini sağlar.
 */
const useLoginChecker = () => {
  const { setAuthData, logoutUser } = useAuthStore()

  const loginChecker = () => {
    const token = Cookie.get('token') as string
    const refreshToken = window.localStorage.getItem('refreshToken') as string

    if (token) {
      axios
        .get(
          `${process.env.NEXT_PUBLIC_IDENTITY_SERVER_AUTHORITY}/connect/userinfo`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then((res) => {
          const resData = res.data as any
          if (resData?.name) {
            setAuthData({
              isAuth: true,
              refreshToken,
              token,
              user: resData,
            })
          }
        })
        .catch((err: any) => {
          console.log('Auth request error: ', err)
          logoutUser()
        })
    }
  }

  return { loginChecker }
}

export default useLoginChecker
